import React, { useState } from "react";

function AuthComponent() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setError("Inserisci un username e una password validi.");
      return;
    }

    setError("");
    setSuccessMessage("");

    try {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }), // Removed action field
      };

      const url = "/angelo/register.php";

      const response = await fetch(url, requestOptions);
      const data = await response.json();

      if (data.error) {
        setError(data.error);
      } else {
        setSuccessMessage(data.success ? "Registrazione avvenuta con successo!" : "");
      }
    } catch (error) {
      setError("Errore durante la comunicazione con il server.");
    }
  };

  return (
    <div className="auth-container">
      <h2 className="auth-title">Registrazione</h2>
      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="username">Username:</label>
          <input
            id="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="form-control"
          />
        </div>
        <button type="submit" className="btn btn-primary">
          Registrati
        </button>
      </form>
      {error && <div className="error-message">{error}</div>}
      {successMessage && <div className="success-message">{successMessage}</div>}
    </div>
  );
}

export default AuthComponent;
